const defaultV = {
  type: Object,
  default: () => { return { $touch: () => {} } }
};

export { defaultV }